import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Aussies and kitties",
  "description": "",
  "published": "2007-05-09T00:00:00.000Z",
  "redirect_from": ["/blog/aussies-and-kitties/swizec/217"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This is a video of my aussie reading a story, it's kind of funny for some absurd reason.`}</p>
    <p>{`And this is, mostly because I can, a depiction of an obsessive compulsively clean person.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      